"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGlobalMonthlyGuildLeaderboardResponseToJSON = exports.GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped = exports.GetGlobalMonthlyGuildLeaderboardResponseFromJSON = void 0;
var _1 = require("./");
function GetGlobalMonthlyGuildLeaderboardResponseFromJSON(json) {
    return GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json, false);
}
exports.GetGlobalMonthlyGuildLeaderboardResponseFromJSON = GetGlobalMonthlyGuildLeaderboardResponseFromJSON;
function GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'members': (json['members'].map(_1.GlobalMonthlyGuildMemberFromJSON)),
    };
}
exports.GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped = GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped;
function GetGlobalMonthlyGuildLeaderboardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'members': (value.members.map(_1.GlobalMonthlyGuildMemberToJSON)),
    };
}
exports.GetGlobalMonthlyGuildLeaderboardResponseToJSON = GetGlobalMonthlyGuildLeaderboardResponseToJSON;
